import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
const topTestimonials = [{
  quote: 'Llevaba 6 años siendo el último en la subida. Tres meses después llegué segundo a la cima.',
  name: 'Marcelo G.',
  desc: 'Ciclista amateur · Buenos Aires'
}, {
  quote: 'Antes acumulaba kilómetros. Ahora acumulo adaptaciones.',
  name: 'Roberto F.',
  desc: 'Ciclista de ruta · Córdoba'
}, {
  quote: 'El bono de presupuestos de nutrición me ahorró una fortuna. Los geles caseros funcionan igual que los importados.',
  name: 'Silvia M.',
  desc: 'Ciclista recreativa · Santa Fe'
}];
export function TopTestimonialsSection() {
  return <section className="py-12 px-4 bg-slate-950 border-b border-slate-800/50" data-id="element-378">
      <div className="max-w-6xl mx-auto" data-id="element-379">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-380">
          {topTestimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-381">
              <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 h-full flex flex-col" data-id="element-382">
                <div className="flex gap-1 mb-4" data-id="element-383">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-384" />)}
                </div>
                <p className="text-slate-300 italic mb-6 flex-grow" data-id="element-385">
                  "{t.quote}"
                </p>
                <div data-id="element-386">
                  <p className="text-white font-bold text-sm" data-id="element-387">{t.name}</p>
                  <p className="text-slate-500 text-xs" data-id="element-388">{t.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}